import { render, staticRenderFns } from "./SAccProjectsList.vue?vue&type=template&id=ca00dddc&scoped=true"
import script from "./SAccProjectsList.vue?vue&type=script&lang=ts"
export * from "./SAccProjectsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca00dddc",
  null
  
)

export default component.exports